import type { FixedLengthArray } from 'type-fest';

import { isArray } from './internal';

export default function isArrayLength<
  ARRAY extends readonly unknown[],
  LENGTH extends ARRAY['length'],
  TYPE extends InferArrayType<ARRAY>,
  FIXED_ARRAY extends FixedLengthArray<TYPE, LENGTH>,
>(value: unknown, length: NonNegativeInteger<LENGTH>): value is FIXED_ARRAY {
  return isArray(value) && value.length === length;
}
